import React from 'react';

type Props = {
  highlight: string;
  children: string;
};

/**
 * Mark part of a string
 * */
function Mark({ children, highlight }: Props) {
  const parts = children.split(new RegExp(`(${highlight})`, 'gi'));

  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark
            key={i}
            css={{
              // TODO: map #d3f0ef to colorSchematics token
              background: '#d3f0ef',
            }}
          >
            {part}
          </mark>
        ) : (
          part
        ),
      )}
    </>
  );
}

export default Mark;
